import { Circle, Placemark } from '@pbe/react-yandex-maps'
import React, { FC, useState, useMemo } from 'react'
import { balloonCluster } from '@/components/Organisms/Map/balloonsDtp'
import { getColorUnit } from '@/components/Organisms/Map/MapDTP'
import { useGetDetailUnitClusterMutation } from '@/modules/maps/services/homeMapService'

interface Props {
  unit: any
  yMap: any
  zoomState?: number
}

const getzoomedRadius = (zoom: number, radius: number) => {
  // let result = radius
  //
  // if (zoom <= 11) result = 1000
  // else result = radius

  return radius
}

const MapCircle: FC<Props> = ({ unit, zoomState = 1, yMap }) => {
  const [balloonDataCluster, setBalloonDataCluster] = useState<any>(null)
  const [getDetailUnitCluster] = useGetDetailUnitClusterMutation()
  const onLoadDataCluster = async (unit: any) => {
    try {
      const data = await getDetailUnitCluster(unit.id).unwrap()
      setBalloonDataCluster(data)
      yMap.current.setCenter(
        unit.coordinates,
        yMap.current._zoom > 12 ? yMap.current._zoom : 12,
        {
          checkZoomRange: true,
          duration: 500,
        }
      )
    } catch (e) {
      console.log(e)
    }
  }
  const radius = getzoomedRadius(zoomState, unit.radius)
  const text = unit.year ? String(unit.year) : String(unit.id)
  const showText = zoomState >= 14
  const transparentIcon =
    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjwvc3ZnPg=='
  const iconContent = useMemo(() => {
    return `<div style="display: flex; justify-content: center; align-items: center; font-size: 14px; font-weight: bold; color: #0072BC; width: 100%; height: 100%; pointer-events: none;">${text}</div>`
  }, [text])

  return (
    <>
      {zoomState <= 13 ? (
        <Placemark
          geometry={unit.coordinates}
          onBalloonOpen={() => onLoadDataCluster(unit)}
          onBaloonClose={() => setBalloonDataCluster(null)}
          options={{
            preset: 'islands#circleDotIcon',
            iconColor: unit.typeId === 16 ? '#FFD21E' : '#FB3D01',
          }}
          properties={{
            balloonContentBody: balloonCluster(
              false,
              false,
              balloonDataCluster
            ),
          }}
        />
      ) : (
        <Circle
          key={unit.id}
          geometry={[unit.coordinates, radius]}
          options={{
            draggable: false,
            fillColor: unit.typeId === 16 ? '#f7eba877' : '#DB709377',
            strokeColor: getColorUnit(unit.typeId),
            strokeOpacity: 0.8,
            strokeWidth: 5,
          }}
          onBalloonOpen={() => onLoadDataCluster(unit)}
          onBaloonClose={() => setBalloonDataCluster(null)}
          properties={{
            balloonContentBody: balloonCluster(
              false,
              false,
              balloonDataCluster
            ),
          }}
        />
      )}
      {showText && (
        <Placemark
          geometry={unit.coordinates}
          options={{
            iconLayout: 'default#imageWithContent',
            iconImageHref: transparentIcon,
            iconImageSize: [1, 1],
            iconImageOffset: [0, 0],
          }}
          properties={{
            iconContent: iconContent,
          }}
        />
      )}
    </>
  )
}

export default MapCircle
